module.exports = __webpack_public_path__ + "img/loadingSpinner.d14cef6e.gif";